import { useEffect, useState } from 'react';
import { useUpdateReceiptEmail } from '../../../features/checkout/checkoutQueries';
import { FloatingLabelInput } from './FloatingLabelInput';

export interface PayerEmailInputProps {
  invoiceId: string;
  initialEmail?: string;
  onSave?: () => void;
}

export function PayerEmailInput({
  invoiceId,
  initialEmail = '',
  onSave,
}: PayerEmailInputProps): JSX.Element {
  const [email, setEmail] = useState(initialEmail);
  const { mutate: updateEmail, isLoading, error } = useUpdateReceiptEmail();

  // Por seguridad: limpiar el email cuando se refresca o cierra la tab
  useEffect(() => {
    const clearEmail = () => {
      updateEmail({ invoiceId, receipt_email: '' });
    };
    window.addEventListener('beforeunload', clearEmail);
    return () => window.removeEventListener('beforeunload', clearEmail);
  }, [invoiceId, updateEmail]);

  const handleSave = () => {
    if (!email) return;
    updateEmail(
      { invoiceId, receipt_email: email },
      {
        onSuccess: () => {
          onSave?.();
        },
      }
    );
  };

  const errorMessage = error?.message ?? '';

  return (
    <FloatingLabelInput
      id="receipt-email-input"
      type="email"
      label="Email"
      value={email}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
        setEmail(e.target.value)
      }
      onBlur={handleSave}
      disabled={isLoading}
      errorMessage={errorMessage}
      description="Opcional. Aquí te enviaremos el comprobantes e instrucciones de pago."
      width="100%"
    />
  );
}
